export default "__VITE_ASSET__BkOVzef8__"